export default function script_randomTile() {
  const $tileContainer = $('#tileContainer');     //タイル配置のコンテナー
  const $tileItem = $('.PhotoGallery24__item');   //タイルの個々のアイテム

  //画像の順番をランダムに並べ替える関数定義
  function randomTile() {
    const arr = [];

    $tileItem.each(function () {
      arr.push($(this).html());
    });
    arr.sort(function () {
      return Math.random() - Math.random();
    });
    $tileContainer.empty();
    for (let i = 0; i < arr.length; i++) {
      $tileContainer.append('<div class="PhotoGallery24__item">' + arr[i] + '</div>');
    }
  };

  randomTile();  //randomTile関数実行
}
